import { render, staticRenderFns } from "./SearchOptionsHeader.vue?vue&type=template&id=2bc747ee&scoped=true&"
import script from "./SearchOptionsHeader.vue?vue&type=script&lang=js&"
export * from "./SearchOptionsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc747ee",
  null
  
)

export default component.exports